__webpack_require__.p = "https://stg-assets.remote.co/_next/";